import React, { useState, useEffect } from 'react';
import { heroImages, siteInfo } from '../data/mock';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToContent = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Images Carousel */}
      {heroImages.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1500 ease-in-out ${
            index === currentImage ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${image})`
            }}
          />
        </div>
      ))}

      {/* Overlay Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0908]/70 via-[#0a0908]/50 to-[#0a0908]/90" />

      {/* Content */}
      <div className={`relative z-10 h-full flex flex-col items-center justify-center text-center px-4 transition-all duration-1000 ${
        isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}>
        <span className="text-[#8B7355] tracking-[0.3em] md:tracking-[0.4em] text-xs md:text-base mb-4 font-light uppercase">
          {siteInfo.location}
        </span>
        <h1 className="text-[#D4A853] text-3xl md:text-5xl lg:text-7xl font-serif tracking-wider mb-2 px-2">
          {siteInfo.name}
        </h1>
        <div className="w-16 md:w-24 h-[1px] bg-gradient-to-r from-transparent via-[#6B7B4B] to-transparent my-4 md:my-6" />
        <p className="text-[#A69080] text-base md:text-xl tracking-[0.2em] md:tracking-[0.3em] uppercase font-light">
          {siteInfo.tagline}
        </p>
      </div>

      {/* Scroll Indicator */}
      <div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer z-20"
        onClick={scrollToContent}
      >
        <div className="flex flex-col items-center text-[#8B7355] animate-bounce hover:text-[#D4A853] transition-colors">
          <span className="text-xs tracking-[0.3em] mb-2 uppercase">Scroll</span>
          <ChevronDown className="w-5 h-5" />
        </div>
      </div>

      {/* Image Indicators */}
      <div className="absolute bottom-8 right-4 md:right-8 flex gap-2 z-20">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentImage
                ? 'bg-[#D4A853] w-6 md:w-8'
                : 'bg-[#8B7355]/50 hover:bg-[#8B7355]'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
